import React from "react";
import { useContext, useEffect } from "react";
import { Route, useHistory } from "react-router-dom";
import UserContext from "../../context/user/UserContext";

const ProtectedRoute = ({ component: Component, exact, path }) => {
	const { getUserInfo, fetchSettings, user, settings } = useContext(UserContext);
	const history = useHistory();

	const loadUserData = async () => {
		let loadedUserDataResult = null;
		if (!user) {
			loadedUserDataResult = await getUserInfo();
		}

		if (!settings && (loadedUserDataResult || user)) {
			fetchSettings();
		}
	};

	useEffect(() => {
		loadUserData();
	}, [history.location.pathname]);

	return <Route exact={exact} path={path} component={() => <Component user={user} />} />;
};

export default ProtectedRoute;
